import { HISTORY_STORAGE_KEY } from "../../config/constants";

export function getInitialHistory() {
  if (typeof window !== "undefined") {
    try {
      const savedHistory = localStorage.getItem(HISTORY_STORAGE_KEY);
      return savedHistory ? JSON.parse(savedHistory) : [];
    } catch (error) {
      console.error("Error reading history from localStorage", error);
      return [];
    }
  }
  return [];
}
